




















































































































































































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  FraudCheckStatus,
  FraudCheckAdjudicationStatus,
} from "@/admin/types";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import Input from "@/shared/components/ui/Input.vue";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { custodianDisplayName } from "@/shared/custodianSettingsHelper";
import SsnReveal from "@/shared/components/SsnReveal.vue";
import DataOverride from "@/admin/components/utility/fraud/DataOverride.vue";
import { startCase } from "lodash";
import { useNotifierStore } from "@/shared/store/notifier";
import { useFraudCheckStore } from "@/admin/store/fraudcheck";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import {  UserPermission } from "@/shared/types";

@Component({
  components: {
    Input,
    Checkbox,
    Button,
    ErrorSummary,
    SsnReveal,
    DataOverride,
  }
})

export default class FraudCheckQueueDetail extends Vue {
  $router: VueRouter;
  $validator: Validator;
  notifierStore = useNotifierStore();
  fraudCheckStore = useFraudCheckStore();
  rolePermissionStore = useRolePermissionsStore();

  @Prop() queueId: number;

  @Prop() routeToFraudDetail: (queueId: number) => Location;

  @Prop() routeToFraudCheckList: () => Location;

  // form fields
  firstName = "";
  middleName = "";
  lastName = "";
  custodian = null;
  fraudCheckStatus = null;
  phone = "";
  mailingAddress = null;
  physicalAddress = null;
  emailAddress = "";
  dateOfBirth = "";
  familyMembers = [];
  cognitoUsername = "";
  employerName = "";
  enrollmentType = "";
  adjudicationStatus = null;

  // other
  isLoaded = false;
  isSubmitting = false;
  isSubmitDisabled = false;
  showConfirmDisableModal = false;
  showOverride = false;
  showLogs = false;

  fraudCheckLogs = [];

  created (): void {
    this.onQueueIdChanged();
  }

  @Watch("queueId")
  onQueueIdChanged () {
    if (this.isSubmitting) {
      return;
    }

    if (this.queueId) {
      this.isLoaded = false;
      this.fraudCheckStore.fraudDetailLoad(this.queueId).then((response: any) => {
        if (response.error) {
          this.notifierStore.setDanger(response.error);
        } else {
          this.firstName = response.firstName;
          this.middleName = response.middleName;
          this.lastName = response.lastName;
          this.custodian = response.custodian;
          this.phone = response.phone;
          this.familyMembers = response.familyMembers;
          this.emailAddress = response.emailAddress;
          this.dateOfBirth = response.dateOfBirth;
          this.mailingAddress = response.mailingAddress;
          this.physicalAddress = response.physicalAddress;
          this.fraudCheckStatus = response.fraudCheckStatus;
          this.cognitoUsername = response.cognitoUsername;
          this.employerName = response.employerName;
          this.enrollmentType = response.enrollmentType;
          this.adjudicationStatus = response.adjudicationStatus;
        }
        this.isLoaded = true;
      }).catch(err => {
        this.isLoaded = true;
      });
    }
  }

  get isRejectButtonDisabled () {
    return this.isSubmitDisabled || this.fraudCheckStatus === "fail";
  }

  get isAcceptButtonDisabled () {
    return this.isSubmitDisabled || this.fraudCheckStatus === "pass" || this.isAnSsnConflict || this.showOverride;
  }

  get isUpdateAndAcceptButtonDisabled () {
    return this.isSubmitDisabled || this.fraudCheckStatus === "pass" || this.showOverride;
  }

  get isAnSsnConflict () {
    return !!this.fraudCheckStore.getEmailOfSsnConflict;
  }

  get canRevealSsn () {
    return this.rolePermissionStore.userHasAdminPermission(UserPermission.AdminPortalRevealPersonalInformation);
  }

  toggleLogs () {
    if (!this.showLogs) {
      this.fraudCheckStore.fraudCheckLogsLoad(this.queueId).then(response => {
        this.fraudCheckLogs = response;
      });
    }
    this.showLogs = !this.showLogs;
  }

  onOverrideDataUserClick () {
    this.showOverride = true;
  }

  onSetFraudCheckDetailAcceptedClick () {
    if (this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    this.fraudCheckStore.setFraudCheckDetailAccepted(this.queueId)
      .then(_ => {
        const nextRoute = this.routeToFraudCheckList();
        const onNavigationComplete = () =>
          this.notifierStore.setSuccess(this.emailAddress + " has been accepted");
        this.$router.push(nextRoute, onNavigationComplete);
      })
      .finally(() => this.isSubmitDisabled = false);
  }

  onSetFraudCheckDetailRejectedClick () {
    if (this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    this.fraudCheckStore.setFraudCheckDetailRejected(this.queueId)
      .then(_ => {
        const nextRoute = this.routeToFraudCheckList();
        const onNavigationComplete = () =>
          this.notifierStore.setSuccess(this.emailAddress + " has been rejected");
        this.$router.push(nextRoute, onNavigationComplete);
      })
      .finally(() => this.isSubmitDisabled = false);
  }

  onUpdateAdjudicationStatusClick () {
    if (this.isSubmitDisabled) {
      return;
    }
    this.isSubmitDisabled = true;
    this.fraudCheckStore.setFraudCheckAdjudicationStatus({ queueId: this.queueId, adjudicationStatus: this.adjudicationStatus })
      .then(_ => {
        const nextRoute = this.routeToFraudCheckList();
        const onNavigationComplete = () =>
          this.notifierStore.setSuccess("Adjudication Status has been updated");
        this.$router.push(nextRoute, onNavigationComplete);
      })
      .finally(() => this.isSubmitDisabled = false);
  }

  onReturnToListClick () {
    this.$router.push(this.routeToFraudCheckList());
  }

  cancelDisableAccount () {
    this.showConfirmDisableModal = false;
  }

  showConfirmDisableAccount () {
    this.$validator.validateAll()
      .then(isValid => {
        if (!isValid) {
          return;
        }
        this.showConfirmDisableModal = true;
      });
  }

  onClose () {
    this.showConfirmDisableModal = false;
  }

  get physicalMapHref () {
    return "https://www.bing.com/maps?q="
      + encodeURIComponent(this.physicalAddress.address1 + " "
        + this.physicalAddress.city + ", "
        + this.physicalAddress.stateCode + " "
        + this.physicalAddress.zip);
  }

  get fraudQueueAdjudicationSelectOptions () {
    return Object.keys(FraudCheckAdjudicationStatus)
      .filter(k => FraudCheckAdjudicationStatus[k] !== FraudCheckAdjudicationStatus.None)
      .map(k => ({ value: FraudCheckAdjudicationStatus[k], text: this.adjudicationStatusDisplay(k) }));
  }

  get areAddressesIdentical () {
    if (!this.physicalAddress || !this.mailingAddress) { return false; }

    return this.physicalAddress.address1 === this.mailingAddress.address1 &&
      this.physicalAddress.address2 === this.mailingAddress.address2 &&
      this.physicalAddress.city === this.mailingAddress.city &&
      this.physicalAddress.stateCode === this.mailingAddress.stateCode &&
      this.physicalAddress.zip === this.mailingAddress.zip;
  }

  adjudicationStatusDisplay (k) {
    let lookUpValue = k;
    if (FraudCheckAdjudicationStatus[k] !== undefined) {
      lookUpValue = FraudCheckAdjudicationStatus[k];
    }
    switch (lookUpValue) {
      case FraudCheckAdjudicationStatus.None:
        return "None";
      case FraudCheckAdjudicationStatus.NeedsReview:
        return "Needs Review";
      case FraudCheckAdjudicationStatus.InProcess:
        return "In-Process";
      case FraudCheckAdjudicationStatus.ReviewComplete:
        return "Review Complete";
      case FraudCheckAdjudicationStatus.AutoReviewed:
        return "Auto Reviewed";
      case FraudCheckAdjudicationStatus.AwaitingDocuments:
        return "Awaiting Documents";
      case FraudCheckAdjudicationStatus.ChallengeQuestions:
        return "Unanswered Challenge Questions";
    }
  }

  fraudCheckStatusDisplay (k) {
    switch (k) {
      case FraudCheckStatus.None:
        return "None";
      case FraudCheckStatus.FraudCheckRequired:
        return "Fraud Check Required";
      case FraudCheckStatus.Pass:
        return "Pass";
      case FraudCheckStatus.Fail:
        return "Fail";
      case FraudCheckStatus.Error:
        return "Error";
      case FraudCheckStatus.DocumentsRequested:
        return "Documents Requested";
      case FraudCheckStatus.FraudCheckNotRequired:
        return "No Fraud Check Required";
    }
  }

  custodianDisplay (k) {
    return custodianDisplayName(k);
  }

  enrollmentTypeDisplay (k: string) {
    return startCase(k);
  }

  actionTypeDisplay (k: string) {
    const wordToRemove = "FraudQueue";
    if (k === null || k === undefined) {
      return k;
    }
    if (k.indexOf(wordToRemove) !== -1) {
      return k.substring(wordToRemove.length);
    }
    return k;
  }

}
